/* Creazione del check-button per accessibilità */
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Trans } from 'react-i18next';

export default function CheckAccessibilita(props) {
  const inProps = props
  const [checked, setChecked] = React.useState(inProps.accessibilita);
  //funzione per settare lo stato al check
  const handleChange = (event) => {
    setChecked(event.target.checked);
    inProps.callback(event.target.checked);
  };
 // checkbox accessibilità
  return (
    <div className={"checkAccessibilita"}>
        <FormControlLabel control={
        <Checkbox
        size={"small"}
        checked={checked}
        onChange={handleChange}
        color="default"
        inputProps={{ 'aria-label': 'primary checkbox' }}
      />
        } label={<Trans>Accessibilità</Trans>} />
    </div>)}